import AudioRecorder from "audio-recorder-polyfill";
window.MediaRecorder = AudioRecorder;



// WEBPACK FOOTER //
// ./src/polyfill.js